<template>
<div>
  <div class="product-row" v-for="product in products">
    <label>{{product.name}}</label>
    <span class="amount">
      <MoneyFormat class="label-amount" :value="product.price" :currencyCode="form.currency" :hide-subunits="true" />
    </span>
  </div>
</div>
</template>
<script lang="ts">
import { defineComponent } from 'vue'
import { usePaymentForm } from '~/shared/use-payment-form'

export default defineComponent({
  props: {
    text: {
      type: String,
      default: 'Sign me up to the newsletter'
    },
    products: {
      type: Array,
      default: []
    }
  },
  setup() {
    const { setValue, form, settings } = usePaymentForm()

    return {
      form,
    }
  },
})
</script>
<style scoped>
label {
  font-size: 14px;
  color: #222
}
.product-row {
  display: flex;
  padding: 10px 5px;
  justify-content: space-between;
  background: #f7f9fb;
  margin-bottom: 3px;
}
</style>